module.exports = __webpack_public_path__ + "img/feature-cover-bg.122b30d0.png";